import React from "react";

const GridStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 2.99995C2.19995 2.55813 2.55813 2.19995 2.99995 2.19995H5.79995C6.24177 2.19995 6.59995 2.55813 6.59995 2.99995V5.79995C6.59995 6.24177 6.24177 6.59995 5.79995 6.59995H2.99995C2.55813 6.59995 2.19995 6.24177 2.19995 5.79995V2.99995Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 10.2C2.19995 9.75818 2.55813 9.40002 2.99995 9.40002H5.79995C6.24177 9.40002 6.59995 9.75818 6.59995 10.2V13C6.59995 13.4419 6.24177 13.8 5.79995 13.8H2.99995C2.55813 13.8 2.19995 13.4419 2.19995 13V10.2Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3999 2.99995C9.3999 2.55813 9.75806 2.19995 10.1999 2.19995H12.9999C13.4417 2.19995 13.7999 2.55813 13.7999 2.99995V5.79995C13.7999 6.24177 13.4417 6.59995 12.9999 6.59995H10.1999C9.75806 6.59995 9.3999 6.24177 9.3999 5.79995V2.99995Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3999 10.2C9.3999 9.75818 9.75806 9.40002 10.1999 9.40002H12.9999C13.4417 9.40002 13.7999 9.75818 13.7999 10.2V13C13.7999 13.4419 13.4417 13.8 12.9999 13.8H10.1999C9.75806 13.8 9.3999 13.4419 9.3999 13V10.2Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GridStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;